import { ApolloClient, from, HttpLink } from "@apollo/client";
import { createWorkspaceHeaderLink } from "@repo/workspace-route";

import { createCache } from "src/gql/createCache";

const GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string;

const createApolloClient = ({
  workspaceId,
}: {
  workspaceId: string | null;
}) => {
  const cache = createCache();
  const httpLink = new HttpLink({
    uri: GRAPHQL_ENDPOINT,
    credentials: "include",
  });

  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    cache,
    defaultOptions: {
      watchQuery: {
        // Apollo Client 3 の挙動に合わせる
        // 意図せず頻繁にローディング表示が出るのを防ぐため
        notifyOnNetworkStatusChange: false,
      },
    },
    link:
      workspaceId == null
        ? httpLink
        : from([createWorkspaceHeaderLink(workspaceId), httpLink]),
  });
};

export const initializeApollo = (workspaceId: string | null) => {
  return createApolloClient({ workspaceId });
};
